var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function newRuleEditSession(data) {
    var instance = {
        __type: "RuleEditSession:#DecisionsFramework.Design.Flow.Service",
        RuleSessionId: null,
        ShowTestActions: true,
        VisibleFeatures: null,
        ExternalDataSourceId: null,
        HeaderDisplayData: null,
        DesignerMessages: null,
        PromptDisplayData: null,
        SampleDisplayData: null,
        IsFilterApplied: false,
        RuleDesignerSurface: 0 /* RuleDesignerSurface.StatementRule */,
        OpenFromLink: false,
        LinkName: null,
        RuleDisplayData: null
    };
    return __assign(__assign({}, instance), data);
}
export function isRuleEditSession(object) {
    return object.__type === "RuleEditSession:#DecisionsFramework.Design.Flow.Service";
}
